import gql from 'graphql-tag';

export const DELETE_COMMENT = gql`
  mutation deleteComment($commentId: Int!) {
    comment {
      delete(commentId: $commentId)
    }
  }
`;
